/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from "react";
import modal from "../../assets/styles/components/modal.module.css";
import containerModal from "../../assets/styles/components/containerModal.module.css";
import styles from "./ModalGeneric.module.css";
import { Close } from "@mui/icons-material";
import Button from "../Button/Button";

const ModalGeneric = ({
  children,
  onClick,
  title,
  childrenHead,
  modalGenericCustom,
  contentClass,
  headerClass,
  containerClass,
}: {
  onClick: (e?: any) => void;
  title?: string;
  childrenHead?: React.ReactNode;
  children: React.ReactNode;
  modalGenericCustom?: string;
  headerClass?: string;
  contentClass?: string;
  containerClass?: string;
}) => {
  const handleKeyUp = (e: KeyboardEvent) => {
    const keyPressed = e.key;

    if (["Escape"].includes(keyPressed)) {
      onClick();
    }
  };

  useEffect(() => {
    document.addEventListener("keyup", handleKeyUp);

    return () => {
      document.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  return (
    <div
      className={`${modal.containerModal} ${styles.modalGeneric} ${containerClass}`}>
      <div
        className={`${containerModal.containerModal} ${styles.containerModalGeneric} ${modalGenericCustom}`}>
        <div className={`${styles.generic} ${headerClass}`}>
          <div className={styles.title}>
            <h1>{title}</h1>
            {childrenHead}
          </div>
          <div className={containerModal.close}>
            <Button 
              variant="contain"
              typeStyle={["small", "cancel"]}
              onClick={onClick}
            >
              <Close />
            </Button>
          </div>
        </div>
        <div className={contentClass}>{children}</div>
      </div>
    </div>
  );
};

export default ModalGeneric;
